import styled from "styled-components";

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ModalContainer = styled.div`
  background: #ffffff;
  border-radius: 4px;
  width: 480px;
  max-width: 90vw;
  box-shadow: 0px 20px 25px -5px rgba(0, 0, 0, 0.1),
    0px 8px 10px -6px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const ModalHeader = styled.div`
  background-color: #3a4048;
  border-bottom: 1px solid #3a4048;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px;
`;

export const ModalTitle = styled.h2`
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  line-height: 28px;
  letter-spacing: -0.44px;
  color: #f8f8f8;
`;

export const ModalCloseButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  color: #f8f8f8;
  font-size: 18px;
  line-height: 1;
  opacity: 0.8;

  &:hover {
    opacity: 1;
  }
`;

export const ModalBody = styled.div`
  padding: 24px;
  background: #ffffff;
`;

export const ModalMessage = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 20px;
  color: #333333;
`;

export const ModalFooter = styled.div`
  background-color: #f8f8f8;
  border-top: 1px solid #ebebeb;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 24px;
  padding: 24px;
  box-sizing: border-box;
`;

export const SecondaryButton = styled.button`
  background: #ffffff;
  border: 1px solid #dfdfdf;
  border-radius: 4px;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  color: #7f7f7f;
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    background: #f8f8f8;
  }
`;

export const PrimaryButton = styled.button`
  background: #5582ba;
  border: none;
  border-radius: 4px;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  color: #ffffff;
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    background: #4a72a8;
  }
`;
